var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author Jinwoo Park
 * @contact libfairy720@datasolution.kr
 * @date 2023-06-28
 * @brief SEI 운영관리 개발
 *
 ********************************************************************/
import DataConsentMain from "@components/dashBoard/operationmanagement/dataconsent/DataConsentMain";
import EquipmentEdit from "@components/dashBoard/operationmanagement/equipment/EquipmentEdit";
import EquipmentMultiRegist from "@components/dashBoard/operationmanagement/equipment/EquipmentMultiRegist";
import EquipmentRegist from "@components/dashBoard/operationmanagement/equipment/EquipmentRegist";
import OperationManagementTree from "@components/dashBoard/operationmanagement/OperationManagementTree";
import OperationManagementView from "@components/dashBoard/operationmanagement/OperationManagementView";
import SiteCreate from "@components/dashBoard/operationmanagement/site/SiteCreate";
import SitemMain from "@components/dashBoard/operationmanagement/site/SiteMain";
import UserList from "@components/dashBoard/operationmanagement/user/UserList";
import { adminApprovalState, adminTabState, adminTypeState, curAdminTreeState } from "@recoil/assessmentState";
import { useTrans } from "@utils/langs/useTrans";
import { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
// component
function OperationManagementMain() {
    const t = useTrans();
    // recoil
    const recoilTab = useRecoilValue(adminTabState);
    const recoilApproval = useRecoilValue(adminApprovalState);
    const setRecoilType = useSetRecoilState(adminTypeState);
    const [recoilTree, setRecoilTree] = useRecoilState(curAdminTreeState);
    //props
    const { handleOpenPop } = useOutletContext();
    // useState
    const [adminType, setAdminType] = useState(recoilTab); // SITE, DEVICE,USER
    const [workMode, setWorkMode] = useState("READ"); //  CREATE, UPDATE, DELETE, READ,
    const [deviceInfo, setDeviceInfo] = useState(null);
    // width Check용
    const [isMobile, setMobile] = useState(false);
    const [is1650M, setIs1650M] = useState(false);
    useEffect(() => {
        // resize handler
        // Mobile 체크
        function handleResize() {
            if (window.innerWidth <= 1650) {
                setIs1650M(true);
            }
            else {
                setIs1650M(false);
            }
            if (window.innerWidth <= 940) {
                setMobile(true);
                if (adminType == "DATA") {
                    onClickTab("SITE");
                }
            }
            else {
                setMobile(false);
            }
        }
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    });
    // isMobile 여부 랜더링 후 확인
    useDebounceEffect(() => __awaiter(this, void 0, void 0, function* () {
        if (window.innerWidth <= 940) {
            setMobile(true);
        }
        if (window.outerWidth <= 1650) {
            setIs1650M(true);
        }
    }), 100);
    function onClickTab(adminType) {
        setAdminType(adminType);
        if (adminType == "DATA") {
            setRecoilTree({
                company: { companyId: recoilTree.company.companyId, companyName: recoilTree.company.companyName },
                zone: { zoneId: recoilTree.zone.zoneId, zoneName: recoilTree.zone.zoneName },
                subZone: { subZoneId: recoilTree.subZone.subZoneId, subZoneName: recoilTree.subZone.subZoneName },
                room: { roomId: "", roomName: "" },
            });
            setRecoilType(recoilTree.subZone.subZoneId ? "subZone" : "zone");
        }
    }
    return (_jsx(_Fragment, { children: _jsxs("main", Object.assign({ className: "container" }, { children: [_jsx(OperationManagementTree, { handleOpenPop: handleOpenPop, setWorkMode: setWorkMode, onClickTab: onClickTab, isMobile: isMobile }), recoilTree.zone.zoneId && adminType !== "BATCH" && workMode == "READ" ? (_jsxs("section", Object.assign({ className: "content wcal-296" }, { children: [_jsxs("article", Object.assign({ className: "box" }, { children: [_jsxs("div", Object.assign({ className: "box__header flex-column brd-bottom-0 pb-0" }, { children: [_jsx(OperationManagementView, { handleOpenPop: handleOpenPop }), _jsxs("ul", Object.assign({ className: "tab__line mt-26 pl-12 pr-36 m-fix" }, { children: [_jsx("li", Object.assign({ className: adminType == "SITE" ? "on" : "", onClick: (e) => onClickTab("SITE") }, { children: _jsx("a", Object.assign({ href: "#", onClick: (e) => e.preventDefault() }, { children: "Site Info" })) })), recoilApproval.approval == 2 && (_jsx("li", Object.assign({ className: adminType == "DEVICE" ? "on" : "", onClick: (e) => onClickTab("DEVICE") }, { children: _jsx("a", Object.assign({ href: "#", onClick: (e) => e.preventDefault() }, { children: t("라벨.운영설비") })) }))), recoilApproval.approval == 2 && (_jsx("li", Object.assign({ className: adminType == "USERS" ? "on" : "", onClick: (e) => onClickTab("USERS") }, { children: _jsx("a", Object.assign({ href: "#", onClick: (e) => e.preventDefault() }, { children: t("운영관리.사용자목록") })) }))), recoilApproval.approval == 2 && !isMobile && (_jsx("li", Object.assign({ className: adminType == "DATA" ? "on" : "", onClick: (e) => onClickTab("DATA") }, { children: _jsx("a", Object.assign({ href: "#", onClick: (e) => e.preventDefault() }, { children: t("운영관리.데이터동의관리") })) })))] }))] })), adminType == "SITE" ? (_jsx(SitemMain, { workMode: workMode, handleOpenPop: handleOpenPop, onClickTab: onClickTab, isMobile: isMobile })) : adminType == "DEVICE" ? (_jsx(EquipmentRegist, { handleOpenPop: handleOpenPop, deviceInfo: deviceInfo, setDeviceInfo: setDeviceInfo, onClickTab: onClickTab })) : adminType == "USERS" ? (_jsx(UserList, { handleOpenPop: handleOpenPop })) : (adminType == "DATA" && _jsx(DataConsentMain, { handleOpenPop: handleOpenPop }))] })), adminType == "DEVICE" && deviceInfo && (_jsx(EquipmentEdit, { handleOpenPop: handleOpenPop, deviceInfo: deviceInfo, is1650M: is1650M }))] }))) : adminType == "SITE" && workMode == "CREATE" ? (_jsx(SiteCreate, { handleOpenPop: handleOpenPop, setWorkMode: setWorkMode })) : adminType == "BATCH" ? (_jsx(EquipmentMultiRegist, { handleOpenPop: handleOpenPop, onClickTab: onClickTab, isMobile: isMobile })) : (_jsx("section", Object.assign({ className: "content wcal-296 " }, { children: _jsx("article", Object.assign({ className: "box nodata" }, { children: _jsxs("p", Object.assign({ className: "nodata__txt", style: { height: "80vh" } }, { children: [t("운영관리.NODATA.사업장"), _jsx("br", {}), t("운영관리.NODATA.사업장추가")] })) })) })))] })) }));
}
export default OperationManagementMain;
export function useDebounceEffect(fn, waitTime, deps) {
    useEffect(() => {
        const t = setTimeout(() => {
            fn.apply(undefined, deps);
        }, waitTime);
        return () => {
            clearTimeout(t);
        };
    }, deps);
}
